import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TextBox } from './text-box';
export { TextBox };
import { textBoxSchema } from '@schemas/business-objects/text-box';
import { ResourceFormGroup } from './resource-form-group';
import type { User } from './user';

export class TextBoxFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    fixedPosition: SchemaFormControl;
    sequence: SchemaFormControl;
    positionX: SchemaFormControl;
    positionY: SchemaFormControl;
    locked: SchemaFormControl;
    resourceId: SchemaFormControl;
    resource: ResourceFormGroup;
  };

  declare value: Partial<TextBox>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(textBoxSchema, TextBox, data, options);
  }

  get object(): TextBox {
    return new TextBox(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'resource':
        return new ResourceFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TextBox[]> {
    return TextBox.find(filter);
  }

  static async findOne(filter?: any): Promise<TextBox | null> {
    return TextBox.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<TextBox> {
    return TextBox.findById(id, filter);
  }

  static async create(data: Partial<TextBox>): Promise<TextBox> {
    return TextBox.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<TextBox>,
  ): Promise<TextBox> {
    return TextBox.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return TextBox.deleteById(id);
  }

  async dataForCopy(): Promise<any> {
    const instance = new TextBox(this.getRawValue());
    return instance.dataForCopy();
  }
}

export class TextBoxFormArray extends PersistedFormArray {
  readonly entityName = 'TextBox' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(textBoxSchema, TextBox, options);
  }

  protected override createItemGroup() {
    return new TextBoxFormGroup();
  }

  get array(): TextBox[] {
    return this.controls.map((group: TextBoxFormGroup) => group.object);
  }
}

export class TextBoxPersistedArray extends PersistedArray<TextBox> {
  readonly entityName = 'TextBox' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TextBox, options);
  }
}
